import { DeleteModal } from "@/components/modal/DeleteModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { deleteSubInterfaceMutation } from "@/modules/compute/vmInterfacesQuery.ts";
import { Trans } from "@lingui/react/macro";

export function SubInterfaceDeleteModal({
    uuid,
    ifUuid,
    location,
}: {
    uuid: string;
    ifUuid: string;
    location: string;
}) {
    const deleteMutation = useStandardMutation(deleteSubInterfaceMutation);

    return (
        <DeleteModal
            inTable
            modalAction={async () => {
                await deleteMutation.mutateAsync({
                    location,
                    uuid,
                    ifUuid,
                });
            }}
        >
            <Trans>Are you sure you want to delete sub-interface with uuid {ifUuid}?</Trans>
        </DeleteModal>
    );
}
